import { AppBar, Stack, Typography } from '@mui/material';
import Cart from 'src/components/Cart';
import React from 'react';

function CartPage() {
  return (
    <Stack
      width='100%'
      height='100%'
      justifyContent='space-between'
      sx={{
        bgcolor: (theme) => theme.palette.light.main
      }}
    >
      <AppBar position='static' sx={{ height: 'fit-content', zIndex: 1000 }}>
        <Typography variant='h4' color='white' my={1}>
          Cart
        </Typography>
      </AppBar>
      <Stack width='100%' height='100%' overflow='auto'>
        <Cart />
      </Stack>
    </Stack>
  );
}

export default CartPage;
